export default __webpack_public_path__ + "static/media/img-0630-moldova-full-face.7d024332.png";